import { render, staticRenderFns } from "./ChatMessageBubbleRow.vue?vue&type=template&id=46165d51&scoped=true"
import script from "./ChatMessageBubbleRow.vue?vue&type=script&lang=js"
export * from "./ChatMessageBubbleRow.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageBubbleRow.vue?vue&type=style&index=0&id=46165d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46165d51",
  null
  
)

export default component.exports